module.exports = __webpack_public_path__ + "img/LC1.df7b5ed9.svg";